// React
import React, { useContext, useEffect } from 'react';
import { Routes, Route, NavLink } from 'react-router-dom';

// Global Context
import { GlobalContext } from '../../contexts/Global';

// Components
import Sidebar from '../../components/Sidebar/Sidebar';

// Pages
import MainCersPage from './pages/Main';
import MembersList from './pages/Members';
import MemberPage from './pages/Member';
import ConventionalAreasPage from './pages/ConventionalAreas';

const CersModule = () => {
    const { currentModule, setCurrentModule } = useContext(GlobalContext);

    useEffect(()=> {
        if (!currentModule || currentModule.id !== 'cers') {
            setCurrentModule({
                id: 'cers',
                name: 'Cers'
            });
        }
    }, [ currentModule ]);

    return (
        <>
            <Sidebar label={ currentModule?.name }>
                <div className="module-menu">
                    <ul className="section">
                        <li>CERS</li>
                        <ul>
                            <li>
                                <NavLink to="/cers" end>Comunità energetica</NavLink>
                            </li>
                            <li>
                                <NavLink to="/cers/members" end>Lista membri</NavLink>
                            </li>
                            <li>
                                <NavLink to="/cers/areas" end>Lista cabine primare</NavLink>
                            </li>
                        </ul>
                    </ul>
                </div>
            </Sidebar>

            <div className="page">
                <Routes>
                    <Route path="" element={ <MainCersPage /> } />
                    <Route path="/members" element={ <MembersList /> } />
                    <Route path="/member" element={ <MemberPage /> } />
                    <Route path="/member/:memberId" element={ <MemberPage /> } />
                    <Route path="/areas" element={ <ConventionalAreasPage /> } />
                </Routes>
            </div>
        </>
    );
}

export default CersModule;
